// import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';

import { AgreementType } from 'Type/Account.type';
import { MixType } from 'Type/Common.type';
import { EventsType, FieldAttrType } from 'Type/Field.type';

import FormAgreement from './FormAgreement.component';
import { DISPLAY_MODE_LINK } from './FormAgreement.config';

/** @namespace PeggysagePwa/Component/FormAgreement/Container */
export class FormAgreementContainer extends PureComponent {
    static propTypes = {
        agreement: AgreementType.isRequired,
        attr: FieldAttrType.isRequired,
        events: EventsType,
        mix: MixType
    };

    static defaultProps = {
        events: {},
        mix: {}
    };

    labelRef = createRef();

    containerFunctions = {
        // getData: this.getData.bind(this)
    };

    componentDidMount() {
        this.addEventListenersOnLinks();
    }

    addEventListenersOnLinks() {
        if (this.labelRef && this.labelRef.current) {
            const links = this.labelRef.current.querySelectorAll('a');
            if (links.length) {
                links.forEach((elt) => {
                    elt.addEventListener('click', this.onLinkClick.bind(this));
                });
            }
        }
    }

    onLinkClick(event) {
        const { agreement: { link, display_mode } } = this.props;

        event.preventDefault();
        event.stopPropagation();

        if (display_mode === DISPLAY_MODE_LINK && link) {
            // Open in new tab
            window.open(link, '_blank');
        } else {
            // ...
        }
    }

    containerProps() {
        const {
            agreement, attr, events, mix
        } = this.props;

        return {
            agreement,
            attr,
            events,
            mix,
            labelRef: this.labelRef
        };
    }

    render() {
        return (
            <FormAgreement
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default FormAgreementContainer;
